<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->

    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('organization'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn color="secondary" prepend-icon="mdi-plus" @click="compose" >              
              <template v-slot:prepend >
                <v-icon color="black"></v-icon>
              </template>
              Add organization
            </v-btn> -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_organization") }}
          </v-btn>
          <!-- <v-btn color="secondary" prepend-icon="mdi-plus" @click="reload" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') ">              
              <template v-slot:prepend >
                <v-icon color="black"></v-icon>
              </template>
              testing
            </v-btn>  -->
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="mb-4">
          <v-col cols="4">
            <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
          </v-col>
          <v-col cols="4"> </v-col>
        </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-card-title>
        <v-spacer></v-spacer>
        
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="organizations"
        class="elevation-1 custom-table-style"
        :search="search"
      >
        <!-- <template v-slot:item.status="{ item }">              
              <td>{{item.value.status}}</td>              
          </template> -->
        <template v-slot:item.status="{ item }">
          {{ item.raw.status }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.id)"
                v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.raw.id)"  >mdi-pencil-circle</v-icon>
              <v-icon color="red" small @click="compose_delete(item.raw.id)"  >mdi-delete-circle</v-icon> -->
        </template>
        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD ORG DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_organization") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('organization_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="org_data.f_orgName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('Select Status')"
                      v-model="org_data.f_status"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addOrg"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_organization") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                     :label="$t('organization_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="org_data.f_orgName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('Select Status')"
                      v-model="org_data.f_status"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateOrg"
                >{{
            $t("Update")
          }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                 
                  <v-btn color="blue-darken-1" variant="text" @click="deleteOrg">Delete</v-btn>               
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteOrg">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Organization",

  data() {
    return {
      name: "",
      emits: ["reload"],
      organizations: [], //used
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      org_data: {
        //used
        f_orgName: "",
        f_parentId: "",
        f_status: "",
      },

      orgId_2: "",
      search: "",
      headers: [
        {
          title: "Org ID",
          align: "start",
          sortable: false,
          key: "id",
        },
        { title: this.$t("organization_name"), key: "orgName" },
        { title: this.$t("Status"), key: "status" },
        { title:this.$t("Actions"), key: "actions", sortable: false },
      ],

      //form
      form: false,
      loading: true,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  methods: {
    reload() {
      // console.log("id", "refreshing1");
      this.$emit("reload");
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput(){
        this.org_data.f_orgName = "";
        this.org_data.f_parentId = "";
        this.org_data.f_status = "";
    },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
    },

    compose_update(id) {
      this.orgId_2 = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.orgId_2 = id;
      // console.log("id", id);
      this.dialog_delete = true;
    },

    async addOrg() {
      //this.dialog = false
      // console.log("form data", this.org_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "" + "organizations",
          {
            orgName: this.org_data.f_orgName,
            parentId: this.orgId,
            status: this.org_data.f_status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        if (result.status == 201) {
          //alert("successfull");
          //this.show_toast(true, "success", "Successful");
          this.$root.vtoast.show({
            message: this.$t("organization_created")
          });
          window.setInterval(() => {
            this.dialog = false;
            //this.$router.go();
            this.$emit("reload");
          }, this.wainting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if(error.response.status == 417){
            this.$root.vtoast.showError({message: error.response.data.message})
          }else if(error.response.status == 500){
            this.$root.vtoast.showError({message: error.response.data.detail})
          }else{
            this.$root.vtoast.showError({message: error.response.data.message})
          }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "organizations/" + this.orgId_2, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", org_response.data);

            //get data for selected id and display data in for dialog
            if (org_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              //console.log("org Data", this.org_response)
              this.org_data.f_orgName = org_response.data.orgName;
              this.org_data.f_status = org_response.data.status;
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateOrg() {
      //this.dialog_update = false
      // console.log("update form org id", this.orgId_2);
      // console.log("update form org", this.org_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.put(
          window.baseurl + "" + "organizations/" + this.orgId_2,
          {
            orgName: this.org_data.f_orgName,
            //parentId:this.orgId,
            status: this.org_data.f_status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        // console.log("update form org result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Updated");
          this.$root.vtoast.show({
            message: this.$t("organization_updated"),
          });

          window.setInterval(() => {
            this.dialog_update = false;
            //this.$router.go();
            //this.$router.push({name:'Organization'})
            this.reload();
          }, this.wainting_time);
          //this.$router.go();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if(error.response.status == 417){
            this.$root.vtoast.showError({message: error.response.data.message})
          }else if(error.response.status == 500){
            this.$root.vtoast.showError({message: error.response.data.detail})
          }else{
            this.$root.vtoast.showError({message: error.response.data.message})
          }
      }
    },

    async deleteOrg() {
      this.dialog_delete = false;
      // console.log("ddddd", this.orgId_2);
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "organizations/" + this.orgId_2,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );
        // console.log("Status", result.status);
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({
            message: this.$t("organization_deleted")
          });
          window.setInterval(() => {
            //this.$router.go();
          }, this.wainting_time);
          //this.$router.go();
          this.fetchData();
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        //if(this.global_permissions.includes("ROLE_STAFF_ADMIN")){
        result = await axios.get(window.baseurl + "organizations", {
          headers: {
            params: { page: page2 },
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });
        // console.log("org_object", result);
        this.organizations = result.data.records;
        this.totalItems = result.data.totalRecords; // Set the total number of items
        this.itemsPerPage = result.data.pageSize;
        this.totalPages = result.data.totalPages;
        this.loading = false;
        //}
        /* else if(this.global_permissions.includes("ORGANIZATION_VIEW")){
            result = await axios.get(window.baseurl+"org/get/"+ this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} } ); 
            console.log("org_object", result);
            this.organizations = result.data;          
          }  */
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        // console.log("error", error);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
          result = await axios.get(window.baseurl + "organizations/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("organisation_object", result);
          this.acquirer = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;

          this.loading = false;
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    validateName(value) {
      const regex = /^[A-Za-z0-9_. ]+$/;
      return (
        regex.test(value) ||
        "Name can only be numbers, characters, space, underscore and ."
      );
    },
  },

  /* beforeMount(){
      //console.log("before mount");
      this.checkTokenExpiry(); 
    }, */

  created() {},

  mounted() {
    //console.log("mount", this.timeLeftInSeconds);

    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  } */
</style>
